import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "@/components/site/Seo";
import PageHeader from "@/components/site/PageHeader";
import { Reveal } from "@/components/site/Reveal";
import ConceptTag from "@/components/site/ConceptTag";
import StayInLoop from "@/components/sections/StayInLoop";
import { JOURNAL_POSTS } from "@/lib/content";

export default function Journal() {
  return (
    <>
      <Seo title="Journal — RestPower" description="Concept notes and early thinking from the RestPower journey — reimagining the charging stop as a destination." path="/journal" />
      <PageHeader
        overline="Journal"
        title={<>Notes From the Journey.</>}
        intro="Early thinking, concept explorations, and honest updates as we design the RestPower experience. This is a concept series — nothing here describes existing locations or completed developments."
      />

      <section className="bg-rp-bg" data-testid="journal-list">
        <div className="mx-auto max-w-7xl px-6 py-20 md:px-12 md:py-28">
          <div className="grid gap-8 md:grid-cols-3">
            {JOURNAL_POSTS.map((post, i) => (
              <Reveal key={post.slug} delay={i * 0.08}>
                <Link
                  to={`/journal/${post.slug}`}
                  data-testid={`journal-card-${post.slug}`}
                  className="group flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-rp-card transition-colors duration-300 hover:border-rp-accent/40"
                >
                  <div className="relative h-56 overflow-hidden">
                    <img src={post.image} alt={post.title} loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                    {post.concept && <ConceptTag className="absolute left-3 top-3" />}
                  </div>
                  <div className="flex flex-1 flex-col p-6">
                    <div className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.14em] text-white/40">
                      <span className="text-rp-accent">{post.category}</span>
                      <span>·</span>
                      <span>{post.readTime}</span>
                    </div>
                    <h3 className="mt-4 font-display text-xl font-medium tracking-tight text-white group-hover:text-rp-accent">
                      {post.title}
                    </h3>
                    <p className="mt-3 flex-1 text-sm leading-relaxed text-white/55">{post.excerpt}</p>
                    <span className="mt-5 inline-flex items-center gap-1 font-mono text-xs uppercase tracking-[0.12em] text-rp-accent">
                      Read <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <StayInLoop />
    </>
  );
}
